module.exports = __webpack_public_path__ + "static/img/solar.baede643.svg";